import * as React from 'react';
import Breadcrumb, {BreadcrumbItem} from '../../components/Breadcrumb';
import Card, {CardHeader, CardBody} from '../../components/Card';
import ChangePasswordForm from '../../containers/ChangePasswordForm';

export default class ChangePassword extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Breadcrumb>
          <BreadcrumbItem href="#">Dashboard</BreadcrumbItem>
          <BreadcrumbItem href="#">Change Password</BreadcrumbItem>
        </Breadcrumb>
        <Card style={{marginTop: 20}}>
          <CardHeader>Change Password</CardHeader>
          <CardBody>
            <ChangePasswordForm />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ChangePassword/ChangePassword.tsx